import React from "react";

import { toastNotify } from "helpers/toastNotify";

export default function ToastDemo() {
  const longString =
    "We are pleased to inform you that your Smart Toast 9000 (ST9000MkII) " +
    "Toaster has encountered an unexpected error.";

  return (
    <div>
      <h3>General Notes</h3>
      <div>
        <p>
          <code>toastNotify</code> is a wrapper around the toast function
          provided by
          <code>react-toastify</code>. It triggers an appearance of the{" "}
          <code>Toaster</code>
          component, from the same library.
        </p>
        <p>
          Our wrapper serves two functions: first, it delays the firing of the
          toast by 300ms for UX reasons alone (this could be converted to a
          passed argument later if we so desire), and secondly it contains the
          theme and styling changes we require.
        </p>
        <p>
          Simply pass in your content as a first argument and any extra content
          as a second argument, optionally. The additional content will be
          displayed to the right of the primary content. If Toasters do not
          appear, perhaps the <code>Toaster</code> component is not rendered in
          the layout or view you are working within.
        </p>
      </div>
      <div>
        <h3>Saving</h3>
        <code>toastNotify(&apos;Saving&apos;)</code>
        <button
          type="button"
          onClick={() => {
            toastNotify("Saving...");
          }}
        >
          Click Me.
        </button>
      </div>

      <div>
        <h3>Saved</h3>
        <div>Second argument is url to link to:</div>
        <code>
          toastNotify(&apos;Guide saved&apos;, &lt;a href=&apos;/&apos;&gt;View
          all&lt;/a&gt;)
        </code>
        <button
          type="button"
          onClick={() => {
            toastNotify("Guide saved", <a href="/">View all</a>);
          }}
        >
          Click Me.
        </button>
      </div>

      <div>
        <h3>Failed to save.</h3>
        <code>
          toastNotify(&apos;Guide failed to save. Please try again.&apos;)
        </code>
        <button
          type="button"
          onClick={() => {
            toastNotify("Guide failed to save. Please try again.");
          }}
        >
          Click Me.
        </button>
      </div>

      <div>
        <h3>Failed to remove</h3>
        <code>
          toastNotify(&apos;Guide failed to remove. Please try again.&apos;)
        </code>
        <button
          type="button"
          onClick={() => {
            toastNotify("Guide failed to remove. Please try again.");
          }}
        >
          Click Me.
        </button>
      </div>

      <div>
        <h3>Long Text</h3>
        <code>toastNotify(&apos;{longString}&apos;)</code>
        <button
          type="button"
          onClick={() => {
            toastNotify(longString);
          }}
        >
          Click Me.
        </button>
      </div>
    </div>
  );
}
